import { render, staticRenderFns } from "./Rank.vue?vue&type=template&id=815ee00c&scoped=true&"
import script from "./Rank.vue?vue&type=script&lang=js&"
export * from "./Rank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815ee00c",
  null
  
)

export default component.exports